@import 'styles/mixins';
@import 'styles/variables';

.dropdown {
  box-shadow: $shadow-s3;
  background: $white;
  border-radius: 8px;
  padding: 4px;
  max-height: 300px;
  width: 300px;
  overflow-y: scroll;
  @include hide-scrollbar;
}

.emoji {
  margin-right: 8px;
  align-items: center;
  flex-shrink: 0;
}

.title {
  @include line-clamp;
}
